import InfoIndicator, { InfoIndicatorProps } from '@ubnt/link-core-ui/components/InfoIndicator/InfoIndicator';
import Checkbox from '@ubnt/ui-components/Checkbox/Checkbox';
import { memo, useCallback, useId } from 'react';
import { Flex, type FlexProps } from 'components/Flex';

import classes from './MLOCheckbox.module.scss';

export interface MLOCheckboxProps extends FlexProps {
  label: string;
  infoText: React.ReactNode;
  checked: boolean;
  disabled: boolean;
  infoIndicatorSeverity: InfoIndicatorProps['severity'];
  onChange: (checked: boolean) => void;
}

const MLOCheckbox = (props: MLOCheckboxProps) => {
  const { checked, disabled, infoIndicatorSeverity, infoText, label, onChange: onChangeProp, ...rest } = props;

  const id = useId();

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChangeProp(event.target.checked);
    },
    [onChangeProp]
  );

  return (
    <Flex gap="xs" alignCenter {...rest}>
      <Checkbox checked={checked} disabled={disabled} id={id} onChange={onChange}>
        {label}
      </Checkbox>
      <InfoIndicator className={classes.infoIndicator} severity={infoIndicatorSeverity} isInteractive>
        {infoText}
      </InfoIndicator>
    </Flex>
  );
};

const MemoizedMLOCheckbox = memo(MLOCheckbox);

export default MemoizedMLOCheckbox;
